import 'aws-amplify/auth/enable-oauth-listener';

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { NonAuthenticatedRoute } from '@/app/constant';
import { useAuth } from '@/state/auth';
import { useGlobalState } from '@/state/global.state';
import { useSearchParams } from '@/utils/url.util';

const AzureMarketplace: React.FC = () => {
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();

  const { searchParams } = useSearchParams();

  const { azureMarketplaceConfig } = useGlobalState();

  useEffect(() => {
    if (searchParams && searchParams.toString()) {
      azureMarketplaceConfig.onChange(Object.fromEntries(searchParams));

      if (isSignedIn) {
        azureMarketplaceConfig.onVerifyLinkingChange(true);
      }
    }
    navigate(isSignedIn ? '/' : NonAuthenticatedRoute.SIGNUP, {
      replace: true,
    });
  }, []);

  return null;
};

export default AzureMarketplace;
